import { render, staticRenderFns } from "./SlidesList.vue?vue&type=template&id=57c6465b&scoped=true"
import script from "./SlidesList.vue?vue&type=script&lang=js"
export * from "./SlidesList.vue?vue&type=script&lang=js"
import style0 from "./SlidesList.vue?vue&type=style&index=0&id=57c6465b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c6465b",
  null
  
)

export default component.exports